export default __webpack_public_path__ + "static/media/object-trash_darkGray1.bcf27082.svg";